<template>
  <div>
    YOU SHALL NOT PASS.
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>
